import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faEnvelope} size="6x" />
    </div>
);

const HubspotForm = ({ state: { formSettings }, isEditMode }) => {
    const { portalId = "", formId = "", region = "na1" } = formSettings || {};

    const target = `hubspot-form-${portalId || ""}-${formId || ""}`;

    useEffect(() => {
        if (!portalId || !formId) {
            return;
        }

        setTimeout(() => {
            window.hbspt.forms.create({
                portalId: portalId,
                formId: formId,
                region: region,
                target: `#${target}`,
            });
        }, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portalId, formId, region]);

    if (!portalId || !formId) {
        return <Icon />;
    }

    return <div id={target}></div>;
};

export default HubspotForm;
